import { AppState } from '../../types';
import {
  MediaViewerState,
} from './types';

export const selectMediaViewer = (state: AppState): MediaViewerState => state.mediaViewer;
